import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'

class Asset {
  constructor ({ path, loader }) {
    this.path = path
    this.loader = loader
    this.promises = []
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  require (callback) {
    this.promises.push(this.promise.then(callback))
  }

  load () {
    this
      .loader(this.path)
      .then(this.resolve)
      .catch(this.reject)

    return Promise.all(this.promises)
  }
}

class Assets {
  constructor (assets) {
    this.load = this.load.bind(this)

    this.items = []

    Object.entries(assets).forEach(([name, asset]) => {
      this.items.push(this[name] = new Asset(asset))
    })
  }

  load () {
    return Promise.all(this.items.map(asset => asset.load()))
  }
}

function gltfLoader (path) {
  return new Promise((resolve, reject) => {
    const loader = new GLTFLoader()
    const dracoLoader = new DRACOLoader()
    dracoLoader.setDecoderPath('/draco/')
    loader.setDRACOLoader(dracoLoader)
    loader.load(path, resolve, () => {}, reject)
  })
}

export const assets = new Assets({
  station: {
    path: '/models/station--4.glb',
    loader: gltfLoader
  }
  // capsule: {
  //   path: '/models/capsule.glb',
  //   loader: gltfLoader
  // },
})
